var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAtmosLogoMain(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 1546.488,
    height: 650.354,
    viewBox: "0 0 1546.488 650.354",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "atmos-logo-main",
    transform: "translate(-226.344 -140.625)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_260",
    "data-name": "Ellipse 260",
    cx: 281.9,
    cy: 281.59,
    rx: 281.9,
    ry: 281.59,
    transform: "translate(354.48 227.8)",
    fill: "#eaf2ec"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_903",
    "data-name": "Group 903",
    transform: "translate(455.973 140.625)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_902",
    "data-name": "Group 902",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2830",
    "data-name": "Path 2830",
    d: "M627.39,251.5c17.76-32.34,26.24-56.1,28.73-63.67a1.725,1.725,0,0,0-1.88-2.26c-14,1.95-77.91,15.78-84.3,105.71a2.7,2.7,0,0,0,2.85,2.35,6.882,6.882,0,0,0,2.67-.64h0S606.46,289.62,627.39,251.5Z",
    transform: "translate(-455.973 -140.625)",
    fill: "#637c67"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2831",
    "data-name": "Path 2831",
    d: "M458.97,140.73a2.29,2.29,0,0,0-2.86,2.92c13.23,36.52,19.91,123.19,95.29,149.93h0l-.31,167.23,10.31.03.33-172.29c1.11-109.06-82.83-141.63-102.75-147.81Z",
    transform: "translate(-455.973 -140.625)",
    fill: "#637c67"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_2832",
    "data-name": "Path 2832",
    d: "M615.79,347.21v9.12h13.94c0,4.87-6.1,7.96-11.64,7.96-8.47,0-14.44-7.39-14.44-15.5s6.1-15.14,14.08-15.14a13.883,13.883,0,0,1,10.63,4.95l8.33-6.96a24.476,24.476,0,0,0-18.97-8.47,25.419,25.419,0,0,0-25.43,25.62c0,14.06,10.84,25.55,26.08,25.55,13.21,0,23.63-8.39,23.63-27.13H615.78Z",
    transform: "translate(-455.973 -140.625)",
    fill: "#637c67"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2833",
    "data-name": "Path 2833",
    d: "M654.35,324.03v49.45h11.28V356.11h2.3l11.35,17.37h13.14l-12.71-18.01c6.4-1.43,11.57-8.11,11.57-15.07,0-8.18-5.17-16.37-16.67-16.37Zm25.57,16.66c0,3.3-2.15,6.53-7.11,6.53h-7.19V333.87h7.47A6.582,6.582,0,0,1,679.92,340.69Z",
    transform: "translate(-455.973 -140.625)",
    fill: "#637c67"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2834",
    "data-name": "Path 2834",
    d: "M752.45,348.72a25.258,25.258,0,1,0-25.22,25.62A25.457,25.457,0,0,0,752.45,348.72Zm-25.29,15c-8.33,0-13.87-6.75-13.87-15s5.53-14.92,13.87-14.92,13.94,6.67,13.94,14.92S735.43,363.72,727.16,363.72Z",
    transform: "translate(-455.973 -140.625)",
    fill: "#637c67"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2835",
    "data-name": "Path 2835",
    d: "M734.99,316.93a5.09,5.09,0,0,0,5.17-5.09,5.032,5.032,0,0,0-5.17-5.02,5.239,5.239,0,0,0-5.46,5.02A5.3,5.3,0,0,0,734.99,316.93Z",
    transform: "translate(-455.973 -140.625)",
    fill: "#637c67"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2836",
    "data-name": "Path 2836",
    d: "M719.61,316.93a5.153,5.153,0,0,0,5.25-5.09,5.1,5.1,0,0,0-5.25-5.02,5.065,5.065,0,1,0,0,10.11Z",
    transform: "translate(-455.973 -140.625)",
    fill: "#637c67"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2837",
    "data-name": "Path 2837",
    d: "M803,373.48V324.03H791.72v28.06l-15.8-28.06H765.57v49.45h11.28V345.06l16.24,28.42Z",
    transform: "translate(-455.973 -140.625)",
    fill: "#637c67"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2838",
    "data-name": "Path 2838",
    d: "M843.35,324.03H831.06l-18.32,49.45h12.07L828.47,362h17.39l3.73,11.48h12Zm-11.79,28.21,5.53-17.44,5.6,17.44Z",
    transform: "translate(-455.973 -140.625)",
    fill: "#637c67"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2839",
    "data-name": "Path 2839",
    d: "M614.49,430.46l-5.17-1.65c-4.6-1.29-4.89-3.52-4.89-4.52,0-2.73,2.3-5.09,5.82-5.09,3.88,0,5.67,2.51,5.67,5.46H627.2c0-9.62-7.26-15.29-16.75-15.29s-17.46,6.25-17.46,15.14c0,4.67,2.09,11.34,13.01,14.29l5.89,1.79c4.38,1.44,5.45,3.23,5.45,5.17,0,3.23-2.8,5.09-6.47,5.09-3.88,0-7.04-2.45-7.04-5.6H592.55c0,9.11,7.33,15.28,17.89,15.28,9.06,0,18.25-4.73,18.25-15.36,0-8.97-7.19-12.56-14.23-14.71Z",
    transform: "translate(-455.973 -140.625)",
    fill: "#637c67"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2840",
    "data-name": "Path 2840",
    d: "M636.51,420.05h13.08v39.62h11.27V420.05h13.09v-9.83H636.51Z",
    transform: "translate(-455.973 -140.625)",
    fill: "#637c67"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2841",
    "data-name": "Path 2841",
    d: "M686.83,398.02a5.231,5.231,0,0,0,5.39,5.09,5.107,5.107,0,0,0,5.24-5.09,5.05,5.05,0,0,0-5.24-5.02A5.227,5.227,0,0,0,686.83,398.02Z",
    transform: "translate(-455.973 -140.625)",
    fill: "#637c67"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2842",
    "data-name": "Path 2842",
    d: "M693.73,410.22l-18.31,49.45h12.07l3.66-11.48h17.39l3.73,11.48h12l-18.25-49.45Zm.5,28.21,5.53-17.44,5.61,17.44Z",
    transform: "translate(-455.973 -140.625)",
    fill: "#637c67"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2843",
    "data-name": "Path 2843",
    d: "M712.78,398.02a5.07,5.07,0,0,0-5.17-5.02,5.24,5.24,0,0,0-5.46,5.02,5.3,5.3,0,0,0,5.46,5.09A5,5,0,0,0,712.78,398.02Z",
    transform: "translate(-455.973 -140.625)",
    fill: "#637c67"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2844",
    "data-name": "Path 2844",
    d: "M753.47,410.22H733.93v49.45h19.54c14.3,0,22.56-10.62,22.56-24.62S767.77,410.22,753.47,410.22Zm0,39.62h-8.26V420.05h8.26c7.4,0,11.2,7.25,11.2,14.99s-3.81,14.79-11.2,14.79Z",
    transform: "translate(-455.973 -140.625)",
    fill: "#637c67"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2845",
    "data-name": "Path 2845",
    d: "M820.98,410.22H783.55v9.83h13.07v39.62H807.9V420.05h13.08Z",
    transform: "translate(-455.973 -140.625)",
    fill: "#637c67"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2846",
    "data-name": "Path 2846",
    d: "M833.3,459.74c0,3.45-1.44,6.25-5.1,6.25a25.174,25.174,0,0,1-6.62-.79l-1,10.19a31.268,31.268,0,0,0,7.62,1.22c12,0,16.38-7.75,16.38-16.87V410.22H833.3Z",
    transform: "translate(-455.973 -140.625)",
    fill: "#637c67"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2847",
    "data-name": "Path 2847",
    d: "M886.56,403.12a5.09,5.09,0,0,0,5.17-5.09,5.032,5.032,0,0,0-5.17-5.02,5.24,5.24,0,0,0-5.46,5.02A5.3,5.3,0,0,0,886.56,403.12Z",
    transform: "translate(-455.973 -140.625)",
    fill: "#637c67"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2848",
    "data-name": "Path 2848",
    d: "M871.18,403.12a5.107,5.107,0,0,0,5.24-5.09,5.05,5.05,0,0,0-5.24-5.02,5.227,5.227,0,0,0-5.39,5.02A5.284,5.284,0,0,0,871.18,403.12Z",
    transform: "translate(-455.973 -140.625)",
    fill: "#637c67"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2849",
    "data-name": "Path 2849",
    d: "M872.68,410.22l-18.31,49.45h12.07l3.66-11.48h17.39l3.73,11.48h12l-18.25-49.45Zm.5,28.21,5.53-17.44,5.61,17.44Z",
    transform: "translate(-455.973 -140.625)",
    fill: "#637c67"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2850",
    "data-name": "Path 2850",
    d: "M939.04,438.28l-15.8-28.06H912.89v49.45h11.28V431.25l16.24,28.42h9.91V410.22H939.04Z",
    transform: "translate(-455.973 -140.625)",
    fill: "#637c67"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2851",
    "data-name": "Path 2851",
    d: "M985.63,430.46l-5.17-1.65c-4.6-1.29-4.89-3.52-4.89-4.52,0-2.73,2.3-5.09,5.82-5.09,3.88,0,5.67,2.51,5.67,5.46h11.28c0-9.62-7.26-15.29-16.75-15.29s-17.46,6.25-17.46,15.14c0,4.67,2.09,11.34,13.01,14.29l5.89,1.79c4.38,1.44,5.45,3.23,5.45,5.17,0,3.23-2.8,5.09-6.47,5.09-3.88,0-7.04-2.45-7.04-5.6H963.69c0,9.11,7.33,15.28,17.89,15.28,9.06,0,18.25-4.73,18.25-15.36,0-8.97-7.19-12.56-14.23-14.71Z",
    transform: "translate(-455.973 -140.625)",
    fill: "#637c67"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2852",
    "data-name": "Path 2852",
    d: "M1007.65,420.05h13.08v39.62h11.28V420.05h13.07v-9.83h-37.43Z",
    transform: "translate(-455.973 -140.625)",
    fill: "#637c67"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2853",
    "data-name": "Path 2853",
    d: "M1068.11,440.36h17.96V430.24h-17.96V420.05h20.47v-9.83h-31.76v49.45h32.41v-9.83h-21.12Z",
    transform: "translate(-455.973 -140.625)",
    fill: "#637c67"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2854",
    "data-name": "Path 2854",
    d: "M1128.42,441.66c6.4-1.43,11.57-8.11,11.57-15.07,0-8.18-5.17-16.37-16.67-16.37h-20.26v49.45h11.28V442.3h2.3l11.349,17.37h13.14Zm-6.9-8.25h-7.19V420.06h7.47a6.582,6.582,0,0,1,6.83,6.82C1128.63,430.19,1126.48,433.41,1121.52,433.41Z",
    transform: "translate(-455.973 -140.625)",
    fill: "#637c67"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_904",
    "data-name": "Group 904",
    transform: "translate(226.344 454.54)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2855",
    "data-name": "Path 2855",
    d: "M230.83,658.45c10.39,0,22.26-7.71,29.68-24.6l62.02-162.14c1.78-4.74,7.12-6.22,12.17-6.22a18,18,0,0,1,4.15.3l65.58,171.04c7.42,16.9,14.24,21.34,26.11,21.64,5.34,0,5.34,6.22,2.97,8.3h-81.9c-2.37-2.08-2.37-8.3,2.97-8.3,10.98,0,22.85-1.48,16.32-18.97l-14.84-37.94H288.7l-10.98,32.31c-4.75,13.64.59,24.6,17.8,24.6H297c5.34-.3,5.34,6.22,2.97,8.3H227.86c-2.37-2.08-2.37-8.3,2.97-8.3Zm61.72-68.47H351.9l-31.75-81.52Z",
    transform: "translate(-226.344 -454.54)",
    fill: "#2f2f2e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2856",
    "data-name": "Path 2856",
    d: "M479.5,535.44h38.87c1.78,5.93-.59,12.15-5.94,12.15H479.49v72.33c0,12.75,1.48,32.31,18.69,32.31,8.01,0,14.84-4.45,23.44-13.93,3.26,1.19,4.45,5.93,3.26,8.89-2.97,9.19-17.51,22.53-37.09,22.53-8.9,0-37.09-3.26-37.09-50.99V547.59H434.68c-5.34,0-4.45-11.56.89-12.15,16.32-4.45,27.89-12.15,35.91-40.91a4.331,4.331,0,0,1,4.15-3.56c2.08,0,3.86,1.48,3.86,4.74v39.72Z",
    transform: "translate(-226.344 -454.54)",
    fill: "#2f2f2e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2857",
    "data-name": "Path 2857",
    d: "M537.96,542.86c10.39-2.97,24.93-6.22,36.8-8.89a20.319,20.319,0,0,1,5.64-.89c4.15,0,6.23,2.37,5.94,8v17.79c9.79-12.15,24.93-26.38,41.84-26.38,17.51,0,31.16,9.19,35.91,28.16,9.79-12.75,25.22-28.16,43.33-28.16,21.37,0,37.39,13.64,37.39,42.98V639.2c0,11.86,1.78,20.45,15.13,20.45,5.34-.3,5.34,5.04,2.97,7.11H699.7c-2.37-2.08-2.37-7.41,2.97-7.12,12.76,0,13.35-9.48,13.35-20.45V580.8c0-19.56-7.42-28.16-19.58-28.16s-24.04,12.45-30.57,21.05V639.2c0,10.67.3,20.45,13.06,20.45,5.04-.3,5.34,5.04,2.97,7.11H620.77c-2.37-2.08-2.37-7.41,2.97-7.11,12.76,0,13.35-9.48,13.35-20.45V580.81c0-19.56-7.71-28.16-19.88-28.16-11.57,0-24.33,13.04-30.86,21.34V639.5c0,10.97.59,20.16,13.35,20.16,5.34-.3,5.34,5.04,2.97,7.11h-64.1c-2.37-2.08-2.37-7.41,2.97-7.11,13.35,0,16.02-8.3,16.02-20.45V561.25c0-10.08-4.15-12.45-9.79-12.45-3.86,0-8.61,1.48-12.46,1.78v-4.74c0-1.48.89-2.37,2.67-2.96Z",
    transform: "translate(-226.344 -454.54)",
    fill: "#2f2f2e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2858",
    "data-name": "Path 2858",
    d: "M780.39,603.63c0-40.91,28.79-71.14,66.18-71.14s65.88,25.5,65.88,66.11-28.79,71.14-65.88,71.14-66.17-25.5-66.17-66.11Zm98.52-5.33c-2.67-30.83-16.32-56.32-35.31-56.32a11.978,11.978,0,0,0-3.26.3c-20.48,2.96-29.68,28.75-26.41,61.66,2.97,31.12,16.32,56.02,35.31,56.02a11.978,11.978,0,0,0,3.26-.3C873.27,656.7,882.18,631.2,878.91,598.3Z",
    transform: "translate(-226.344 -454.54)",
    fill: "#2f2f2e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2859",
    "data-name": "Path 2859",
    d: "M1022.24,540.79c3.56,4.74,4.45,23.42,4.45,28.75-.3,2.97-3.86,3.56-6.23,3.56-9.2-15.71-20.47-30.83-36.5-30.83-10.39,0-18.1,6.52-18.1,16.9,0,30.24,67.949,35.28,68.25,73.81,0,21.34-20.48,36.76-51.34,36.76-19.88,0-37.69-6.52-44.81-13.04-3.26-7.71-3.86-21.34-3.86-30.53,0-3.26,4.15-4.15,6.83-4.15,6.53,16.3,23.74,37.94,43.03,37.94,10.98,0,19.29-7.11,19.29-17.49,0-28.75-66.17-32.02-66.17-71.74,0-24.01,24.04-37.94,52.23-37.94,15.73,0,28.49,4.45,32.94,8.01Z",
    transform: "translate(-226.344 -454.54)",
    fill: "#2f2f2e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2860",
    "data-name": "Path 2860",
    d: "M1053.69,542.87c10.39-2.97,25.22-6.22,36.8-8.89a20.32,20.32,0,0,1,5.64-.89c4.15,0,6.23,2.37,5.94,8.01v10.08c8.9-9.48,22.26-18.67,36.8-18.67,35.61,0,60.54,24.31,60.53,65.51,0,41.5-26.41,71.73-62.02,71.73-12.46,0-24.93-4.74-35.31-13.34v46.24c0,12.75,2.67,20.16,16.32,20.16,5.34,0,5.34,5.04,2.97,7.11H1054.3c-2.37-2.08-2.37-7.12,2.97-7.12,13.65,0,16.02-8,16.02-20.45V561.25c0-9.78-4.45-12.15-10.38-12.15-3.86,0-8.01,1.18-11.87,1.48v-4.74a2.891,2.891,0,0,1,2.67-2.96Zm48.37,90.11c6.53,14.53,20.18,26.98,34.72,26.98.89,0,2.08-.3,2.97-.3,19.29-2.08,32.05-30.24,28.49-63.44-3.26-29.64-19.58-50.99-37.39-50.99-14.84,0-23.74,17.19-28.78,29.05v58.69Z",
    transform: "translate(-226.344 -454.54)",
    fill: "#2f2f2e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2861",
    "data-name": "Path 2861",
    d: "M1215.12,464.32c10.39-2.97,25.52-5.93,37.09-8.89a20.12,20.12,0,0,1,5.34-.89c4.15,0,6.53,2.37,6.23,8V557.4c11.87-12.75,26.71-24.9,45.1-24.9,22.85,0,39.76,13.04,39.76,43.87v62.84c0,12.15,2.97,20.45,16.32,20.45,5.039-.3,5.34,5.04,2.97,7.11h-65.88c-2.37-2.08-2.37-7.41,2.97-7.11,13.35,0,14.84-8.89,14.84-20.45V579.93c0-19.56-10.09-28.16-22.55-28.16-13.06,0-25.52,10.08-33.53,19.56v68.18c0,11.86,1.48,20.16,14.84,20.16,5.34-.3,5.34,5.04,2.97,7.11h-65.88c-2.37-2.08-2.37-7.41,2.97-7.11,13.35,0,16.32-8.3,16.32-20.45V483.3c0-10.08-4.45-12.45-10.08-12.45-3.86,0-8.61,1.48-12.46,1.78v-5.34c0-1.48.89-2.37,2.67-2.97Z",
    transform: "translate(-226.344 -454.54)",
    fill: "#2f2f2e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2862",
    "data-name": "Path 2862",
    d: "M1450.43,532.5c30.86,0,54.9,24.01,57.571,56.03.3,2.97.89,8.89-7.42,8.89l-85.76.29c.889,25.2,19.29,52.76,45.99,52.76,1.48,0,2.67-.3,4.15-.3,13.35-.89,24.331-9.48,32.35-26.38,3.26-.3,9.2,3.85,7.72,8a58.845,58.845,0,0,1-55.491,37.94c-34.129,0-64.1-23.12-64.1-65.51,0-40.31,27.01-71.74,64.99-71.74Zm26.41,53.06c-1.78-21.34-10.679-42.98-29.67-42.98H1444.5c-15.43,1.78-27.6,20.16-29.68,42.98Z",
    transform: "translate(-226.344 -454.54)",
    fill: "#2f2f2e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2863",
    "data-name": "Path 2863",
    d: "M1526.39,542.88c10.39-2.67,25.52-5.93,36.8-8.89a22.056,22.056,0,0,1,5.64-.89c4.15,0,6.23,2.37,5.94,8v25.2c9.5-18.67,23.74-33.79,40.06-33.79,22.549,0,29.67,24.01,12.759,37.65-6.53-5.04-14.24-11.26-22.85-11.26h-1.19c-10.98.59-22.26,10.97-28.78,25.19v55.43c0,12.45,2.97,20.16,16.32,20.16,5.34-.3,5.34,5.04,2.97,7.11H1527c-2.37-2.08-2.37-7.41,2.97-7.12,13.35,0,16.02-8.3,16.02-20.45V561.26c0-9.78-4.45-11.86-10.09-11.86-3.86,0-8.31.89-12.17,1.18v-4.74a2.891,2.891,0,0,1,2.67-2.96Z",
    transform: "translate(-226.344 -454.54)",
    fill: "#2f2f2e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2864",
    "data-name": "Path 2864",
    d: "M1715.12,532.51c30.86,0,54.9,24.01,57.57,56.03.3,2.97.89,8.89-7.42,8.89l-85.761.3c.89,25.2,19.29,52.76,45.99,52.76,1.481,0,2.67-.3,4.151-.3,13.35-.89,24.33-9.49,32.349-26.38,3.26-.3,9.2,3.85,7.72,8a58.845,58.845,0,0,1-55.49,37.94c-34.13,0-64.1-23.13-64.1-65.51C1650.13,563.93,1677.14,532.51,1715.12,532.51Zm26.41,53.06c-1.779-21.34-10.68-42.98-29.669-42.98h-2.67c-15.43,1.78-27.6,20.16-29.681,42.98Z",
    transform: "translate(-226.344 -454.54)",
    fill: "#2f2f2e"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAtmosLogoMain);
export default __webpack_public_path__ + "static/media/atmos-logo-main.da61c9292fa281d70c5d1c1181c05809.svg";
export { ForwardRef as ReactComponent };